import React from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import { ReactComponent as Add } from '@assets/svgs/icons/add.svg'
import { ReactComponent as Minus } from '@assets/svgs/icons/minus.svg'
import PlaceHolder from '@assets/svgs/placeholder.svg'
import './OptionalExtra.module.scss'

const OptionalExtra = ({ extra, increment, decrement }) => {
  const title = R.prop('title', extra)
  const productCode = R.prop('productCode', extra)
  const quantity = R.prop('quantity', extra)
  const imageSrc = R.propOr(PlaceHolder, 'image', extra)

  return (
    <div styleName='product'>
      <div styleName='imageBox'>
        <div styleName='image' style={{ backgroundImage: `url(${imageSrc})` }} />
      </div>
      <div styleName='title'>{title}</div>
      <div styleName='code'>Product Code: {productCode}</div>
      <div styleName='controls'>
        <div styleName='control button' onClick={decrement}>
          <Minus />
        </div>
        <div styleName='control'>{quantity}</div>
        <div styleName='control button' onClick={increment}>
          <Add />
        </div>
      </div>
    </div>
  )
}

OptionalExtra.propTypes = {
  extra: PropTypes.object.isRequired,
  increment: PropTypes.func.isRequired,
  decrement: PropTypes.func.isRequired
}

export default OptionalExtra



// WEBPACK FOOTER //
// ./src/components/ProductSummary/OptionalExtras/OptionalExtra/OptionalExtra.js